class PessoaCadastro {
  constructor() {
    
  }
}
export default PessoaCadastro
